var MarkPriseWxChestClickRedirector = xClass("MarkPriseWxChestClickRedirector", BaseRedirector)
MarkPriseWxChestClickRedirector.prototype.getName = function () {
    var self = this
    return "mark_prise"
}
MarkPriseWxChestClickRedirector.prototype.hasHighPriorityAction = function () {
    return false
}
MarkPriseWxChestClickRedirector.prototype.redirect = function (param) {
    var self = this
    param = param || self.param

    if (isWechatGameEnv()) {
        // 微信签到限时宝箱
        if (param.inviteCode && param.linkCreateTime) {
            if (param.inviteCode == UserManager.getInstance().uid) {
                Toast.make("不能帮自己获得额外奖励，让好友点击吧！")
                return true
            }

            let todayDate = formatDate(new Date(), "yyyyMMdd")
            let linkDate = formatDate(new Date(parseInt(param.linkCreateTime)), "yyyyMMdd")
            if (todayDate != linkDate) {
                Toast.make("链接已失效，无法帮助好友获得奖励")
                return true
            }

            // 格式 {”20180722": [1, 3, 5, 6]} 记录今天是否点击过这个链接
            let markPriseWxClicked = Persistence.readFileData(LocalDataFiles.kMarkPriseWxClicked) || table()
            let todayUids = markPriseWxClicked[linkDate]
            if (todayUids) {
                for (let i = 0; i < todayUids.length; i++) {
                    let uid = todayUids[i]
                    if (uid == param.inviteCode) {
                        Toast.make("今日已帮助过该好友")
                        return true
                    }
                }
            }

            function onComplete() {
                Toast.make("成功帮助好友获得签到额外奖励")
                let markPriseWxClicked = Persistence.readFileData(LocalDataFiles.kMarkPriseWxClicked)
                let todayUids = markPriseWxClicked && markPriseWxClicked[linkDate]
                if (todayUids) {
                    for (let i = 0; i < todayUids.length; i++) {
                        let uid = todayUids[i]
                        if (uid == param.inviteCode) {
                            // 已经存过了，直接退出
                            return
                        }
                    }
                } else {
                    todayUids = []
                }
                todayUids.push(param.inviteCode)
                let data = {}
                data[linkDate] = todayUids
                Persistence.writeFileData(data, LocalDataFiles.kMarkPriseWxClicked)
            }
            let http = MarkPriseWxChestClickHttp.new(false)
            http.addEventListener(Events.kComplete, onComplete)
            http.addEventListener(Events.kError, onComplete)
            http.load(param.inviteCode, param.linkCreateTime)
        }
    }

    return true
}
module.exports = MarkPriseWxChestClickRedirector